import styles from './RefineRadioItem.less';

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import NavLink from 'src/components/NavLink/NavLink';

import isEqual from 'lodash/isEqual';

export default class RefineRadioItem extends React.Component {
  static propTypes = {
    multiSelect: PropTypes.bool,
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
    refineParams: PropTypes.object,
    path: PropTypes.string.isRequired,
    handleSelection: PropTypes.func,
    preNavigationAction: PropTypes.func
  };

  static defaultProps = {
    multiSelect: false
  };

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.preNavigationAction = this.preNavigationAction.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props, nextProps);
  }

  handleClick(event) {
    const { handleSelection, label } = this.props;
    event.preventDefault();
    handleSelection(label);
  }

  preNavigationAction() {
    const { preNavigationAction, label, multiSelect } = this.props;
    return preNavigationAction({ label, multiSelect });
  }

  render() {
    const {
      multiSelect,
      value,
      label,
      refineParams,
      isActive,
      path
    } = this.props;

    const isDisabled = !refineParams && !isActive;

    const commonProps = {
      'data-automation': value,
      role: multiSelect ? 'checkbox' : 'radio',
      'aria-checked': isActive
    };

    // For aesthetic reasons, hide the dollar sign for values like "$30k" or "$200k+"
    const computedLabel =
      label.indexOf('k') > -1 ? label.replace('$', '') : label;

    return (
      <li
        role="presentation"
        className={classnames({
          [styles.root]: true,
          [styles.root_isActive]: isActive,
          [styles.root_isDisabled]: isDisabled
        })}
      >
        {!isDisabled && <div className={styles.backdrop} />}
        {isDisabled ? (
          <span {...commonProps} aria-hidden="true" className={styles.itemText}>
            {computedLabel}
          </span>
        ) : (
          // We provide a link, even for the selected item
          // so screen readers maintain checkbox/radio selection context
          <NavLink
            onClick={this.handleClick}
            {...commonProps}
            preNavigationHooks={[this.preNavigationAction]}
            aria-label={computedLabel}
            location={{
              pathname: refineParams ? path : null,
              query: refineParams
            }}
            className={styles.itemLink}
          >
            {computedLabel}
          </NavLink>
        )}
      </li>
    );
  }
}
